export const TrashCan = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="8" width="18" height="21" rx="1" stroke="currentColor" stroke-width="2"/>
<rect width="9" height="4" rx="1" transform="matrix(1 0 0 -1 12 8)" stroke="currentColor" stroke-width="2"/>
<path d="M19 13V24" stroke="currentColor" stroke-width="2"/>
<path d="M13 13V24" stroke="currentColor" stroke-width="2"/>
<path d="M4 8H28" stroke="currentColor" stroke-width="2"/>
</svg>`;
